import React, { Fragment } from 'react';
import { STEP_TITLES } from './constants';

const Stepper = ({ currentStep, totalSteps }) => {
  return (
    <div className="w-full mb-4 md:mb-12">
      <div className="flex items-center justify-center">
        {[...Array(totalSteps)].map((_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;

          return (
            <Fragment key={stepNumber}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center
                    font-semibold text-xs md:text-sm transition-all duration-300
                    ${isActive
                      ? 'bg-primary text-white ring-4 ring-primary ring-opacity-30 scale-110'
                      : isCompleted
                        ? 'bg-primary text-white'
                        : 'bg-gray-200 text-gray-500'
                    }
                  `}
                >
                  {isCompleted ? (
                    <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    stepNumber
                  )}
                </div>
                {/* Step Title - Hidden on mobile for compactness */}
                <span className={`
                  hidden md:block mt-2 text-xs font-medium text-center
                  ${isActive ? 'text-primary' : isCompleted ? 'text-gray-700' : 'text-gray-400'}
                `}>
                  {STEP_TITLES[stepNumber]}
                </span>
              </div>

              {/* Connector Line */}
              {stepNumber < totalSteps && (
                <div
                  className={`
                    h-1 w-6 md:w-20 mx-1 md:mx-2 transition-all duration-300
                    ${stepNumber < currentStep ? 'bg-primary' : 'bg-gray-200'}
                  `}
                />
              )}
            </Fragment>
          );
        })}
      </div>

      {/* Mobile Step Title */}
      <div className="md:hidden text-center mt-8">
        <span className="text-xl font-medium text-primary">
          {STEP_TITLES[currentStep]}
        </span>
      </div>
    </div>
  );
};

export default Stepper;
